// notification-socket.service.ts
import { Injectable } from '@angular/core';
import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client/dist/sockjs';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class NotificationSocketService {

  private client!: Client;
  notifications$ = new BehaviorSubject<any[]>([]);

  connect() {

    this.client = new Client({
      webSocketFactory: () =>
        new SockJS(`${environment.agentapiURL}ws`),
      reconnectDelay: 5000,
      debug: () => { }
    });

    this.client.onConnect = () => {
      console.log('✅ WebSocket connected');

      this.client.subscribe('/topic/dev', msg => {
        this.push(JSON.parse(msg.body));
      });
    };

    this.client.activate();
  }

  private push(notification: any) {
    this.notifications$.next([
      notification,
      ...this.notifications$.value
    ]);
  }
}
